import * as React from "react";
import "./main.scss"
import DefaultLayout from "./components/DefaultLayout";
import "./styles/results/publicResults.scss"
import useIOSKeyboardScrollReset from "./components/useIOSKeyboardScrollReset";

export default function App() {
  useIOSKeyboardScrollReset();

  return (

      <DefaultLayout />

  );
}
